<template>
  <div class="right-wrap">
    <RightCard v-if="listStore.hotCert.length > 0" class="hot-rank">
      <template #title>
        <img src="@/src/assets/imgs/common/hot.png" width="11px" height="14px" alt="hot-icon" />
        市场热度榜
      </template>

      <div class="hot-cert-item hot-cert-header">
        <span class="cert-l">证书</span>
        <span class="cert-r">市场热度</span>
      </div>
      <div
        v-for="item in listStore.hotCert"
        :key="item.levelName + item.levelId"
        class="hot-cert-item"
      >
        <nuxt-link class="line-clamp-1 cert-l" :to="item.url" target="_blank">{{
          item.levelName
        }}</nuxt-link>
        <span class="cert-r">{{
          Number(item.popularityScore) > 0 ? item.popularityScore : '--'
        }}</span>
      </div>
    </RightCard>
    <RightCard v-if="listStore.officeCert.length > 0" class="hot-rank">
      <template #title>
        <img src="@/src/assets/imgs/common/hot.png" width="11px" height="14px" alt="hot-icon" />
        招聘需求榜
      </template>

      <div class="hot-cert-item hot-cert-header">
        <span class="cert-l">证书</span>
        <span class="cert-r">招聘需求</span>
      </div>
      <div
        v-for="item in listStore.officeCert"
        :key="'officeCert' + item.levelName + item.levelId"
        class="hot-cert-item"
      >
        <nuxt-link class="line-clamp-1 cert-l" :to="item.url" target="_blank">{{
          item.levelName
        }}</nuxt-link>
        <span class="cert-r">{{ Number(item.officeScore) > 0 ? item.officeScore : '--' }}</span>
      </div>
    </RightCard>
    <ClientOnly>
      <RightCard v-if="listStore.examArticle.length > 0" title="备考攻略" class="exam-article">
        <nuxt-link
          v-for="item in listStore.examArticle"
          :key="item.id"
          class="article-item"
          :to="item.url"
          target="_blank"
        >
          <div class="user-info">
            <img :src="item.userAvatar" alt="avatar" />
            <span class="user-name">{{ item.userName }}</span>
            <span class="time">{{ item.createTime }}</span>
          </div>

          <div class="line-clamp-2 article-title">{{ item.title }}</div>
          <div class="line-clamp-2 article-content">{{ item.content }}</div>
        </nuxt-link>
      </RightCard>
    </ClientOnly>
    <ClientOnly>
      <RightCard v-if="listStore.commentList.length > 0" title="热门问答" class="comment-list">
        <nuxt-link
          v-for="(item, index) in listStore.commentList"
          :key="item.certId"
          :class="{
            'comment-item': true,
            'border-none': index + 1 === listStore.commentList.length,
          }"
          :to="item.url + '?goPosition=discuss'"
          target="_blank"
        >
          <div class="user-info">
            <img :src="item.user.avatar" alt="avatar" />
            <div class="user-info-right">
              <div class="user-info-right-top">
                <span class="user-name">{{ item.user.nickName }}</span>
                <span class="time">{{ item.showTime }}</span>
              </div>
              <div class="cert-tag">{{ item.certName }}</div>
            </div>
          </div>
          <div class="comment-content">
            <div class="line-clamp-4 content">
              {{ item.content }}
            </div>
            <div
              :class="{ 'handle-box': true, 'handle-box-active': item.isLike }"
              @click.stop.prevent="handleLike(item)"
            >
              <img :src="item.isLike ? likeIconAct : likeIcon" width="12" alt="like-icon" />
              {{ item.likeCount }}
            </div>
          </div>

          <div :class="{ 'child-comment-list': true, 'm-t-0': item.childReplayList.length <= 0 }">
            <div
              v-for="(value, i) in item.childReplayList"
              :key="value.commentId"
              :class="{
                'comment-item': true,
                'last-child-comment': i + 1 >= item.childReplayList.length,
              }"
            >
              <div class="user-info">
                <img :src="value.user.avatar" alt="avatar" />
                <div class="user-info-right">
                  <div class="user-info-right-top">
                    <span class="user-name">{{ value.user.nickName }}</span>
                    <span class="time">{{ value.showTime }}</span>
                  </div>
                </div>
              </div>
              <div class="comment-content">
                <div class="line-clamp-4 content">
                  {{ value.content }}
                </div>
                <div
                  :class="{ 'handle-box': true, 'handle-box-active': value.isLike }"
                  @click.stop.prevent="handleLike(value)"
                >
                  <img :src="value.isLike ? likeIconAct : likeIcon" width="12" alt="like-icon" />
                  {{ value.likeCount }}
                </div>
              </div>
            </div>
          </div>
        </nuxt-link>
      </RightCard>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import RightCard from './RightCard.vue';
import { useUserStore } from '~/src/store/modules/user';
import { useListStore } from '~/src/store/modules/certList';
import { fetchLikeDiscuss } from '@/src/api/modules/detail/index';
import likeIcon from '@/src/assets/imgs/detail/like-icon.png';
import likeIconAct from '@/src/assets/imgs/detail/like-icon-act.png';
const userStore = useUserStore();
const listStore = useListStore();

const handleLike = async (row: any) => {
  if (!userStore.isLogin) {
    location.href = userStore.loginUrl;

    return;
  }

  const res = await fetchLikeDiscuss({
    commentId: row.commentId,
  });

  if (res.data === 'add_like') {
    row.likeCount = String(Number(row.likeCount) + 1);
    row.isLike = 1;
  } else {
    row.likeCount = String(Number(row.likeCount) - 1);
    row.isLike = 0;
  }
};
</script>

<style lang="scss">
.cert-list-page {
  .right-wrap {
    width: 240px;
    padding-top: 66px;

    .hot-rank {
      padding-bottom: 10px;

      .right-card-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        img {
          width: 11px;
          height: 14px;
          margin-right: 6px;
        }
      }

      .hot-cert-item {
        display: flex;
        height: 36px;
        align-items: center;
        color: #333333;
        cursor: pointer;

        &:hover {
          .cert-l {
            color: #3d64f3;
          }
        }

        .cert-l {
          width: 163px;
          flex-grow: 1;
          font-size: 14px;
        }

        .cert-r {
          width: 50px;
          font-size: 14px;
          text-align: center;
        }
      }

      .hot-cert-header {
        height: 28px;
        cursor: default;

        .cert-l,
        .cert-r {
          color: #9399a5;
          font-size: 12px;
        }

        &:hover {
          box-shadow: none;
        }
      }
    }

    .comment-list {
      overflow: hidden;

      .right-card-title {
        margin-bottom: 13px;
      }

      .comment-item {
        display: block;
        padding-bottom: 10px;
        border-bottom: solid 1px #edeef0;
        margin-bottom: 10px;

        .user-info {
          display: flex;
          align-items: center;
          margin-bottom: 7px;

          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 8px;
          }

          .user-info-right-top {
            display: flex;
            align-items: center;
            color: #9399a5;
            font-size: 12px;

            .user-name {
              overflow: hidden;
              max-width: 72px;
              margin-right: 10px;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .cert-tag {
            overflow: hidden;
            width: fit-content;
            max-width: 148px;
            padding: 1px 6px;
            border-radius: 2px;
            background-color: #f9bb51;
            color: #ffffff;
            font-size: 12px;
            line-height: 1;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .comment-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #333333;
          font-size: 14px;
          line-height: 19px;

          .content {
            width: 190px;
            min-height: 32px;
            word-break: break-all;
          }

          .handle-box {
            display: flex;
            flex-direction: column;
            flex-shrink: 0;
            align-items: center;
            justify-content: center;
            color: #959ba6;
            font-size: 12px;
          }

          .handle-box-active {
            color: #3d64f3;
          }
        }

        .child-comment-list {
          padding-left: 20px;
          margin-top: 10px;

          .user-info {
            margin-bottom: 0;

            .user-name {
              max-width: 50px;
            }
          }

          .comment-item {
            border-bottom: none;
          }

          .last-child-comment {
            padding-bottom: 0;
            margin-bottom: 0;
          }

          .content {
            width: 164px;
            padding-left: 32px;
            color: #9399a5;
            font-size: 12px;
            word-break: break-all;
          }
        }

        .m-t-0 {
          margin-top: 0;
        }
      }

      .border-none {
        border-bottom: none;
      }
    }

    .exam-article {
      .right-card-title {
        margin-bottom: 15px;
      }

      .article-item {
        display: block;
        padding-bottom: 10px;
        border-bottom: solid 1px #edeef0;
        margin-bottom: 10px;

        &:hover {
          .article-title {
            color: #3d64f3;
          }
        }
      }

      .user-info {
        display: flex;
        align-items: center;
        color: #9399a5;
        font-size: 12px;

        img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-right: 8px;
        }

        .user-name {
          overflow: hidden;
          max-width: 100px;
          margin-right: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .article-title {
        margin: 8px 0 4px;
        color: #333333;
        font-size: 14px;
        line-height: 19px;
      }

      .article-content {
        color: #9399a5;
        font-size: 12px;
        line-height: 19px;
      }
    }
  }
}
</style>
